/*!
 * tempo.js — tempo(): the speed of the beat grid
 * © 2026 Rob Canning — GPLv3
 *
 *     tempo(120)              120 bpm from the next whole beat
 *     tempo(bpm:90)           the same, named
 *     tempo()                 says what it is
 *
 * dur: in synth() is in beats, and quant: waits for beats of this grid
 * (beatGrid.js). The live console adds the beat the change starts on
 * (tempo(120, beat:N)), so the projector window changes on the same one,
 * and in a room tells the room (roomBeat.js), which keeps it for whoever
 * joins later.
 */

import { setTempo, gridBpm } from "./audio/beatGrid.js";
import "./audio/roomBeat.js";              // the room's beat, taken in every window
import { onReset } from "../system/teardown.js";

// A project starts at 60 bpm: the last one's tempo() is let go on the next
// whole beat (setTempo keeps the beat count, so the windows still agree)
onReset("project", function tempoHome() { setTempo(60); });   // a change still to come is replaced too

export function handleTempoCue(ast) {
  const arg = name => ast?.args?.find(a => a.type === name)?.value;
  const bpm = Number(arg("bpm"));
  if (!(bpm > 0)) {
    console.info(`[tempo] ${+gridBpm().toFixed(2)} bpm`);
    return null;
  }
  const beat = arg("beat");
  return setTempo(bpm, beat != null && Number.isFinite(Number(beat)) ? Number(beat) : undefined);
}
